export enum DocumentFileType {
  MANUFACTURER = 'MANUFACTURER_DOCUMENT',
  USER = 'GENERIC_FILE',
  GATED_DOCUMENT = 'GATED_CONTENT',
  MAINTENANCE_REPORT = 'MAINTENANCE_REPORT',
  INTERNAL = 'INTERNAL_DEVICE_DOCUMENT',
  FREE_CONTENT = 'FREE_CONTENT',
}
